import React, {useState } from 'react';
import {Grid , Chip, ListItem, ListItemIcon, ListItemText, Divider} from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {Today, LocationOn, AccountCircle, Person, Wc,  } from '@material-ui/icons';
import BotonPersonalizado from 'components/BotonNormal'
import {functions} from 'constants/index';
import DatosDeIdentidadCiudadano from '../datosDeIdentidadCiudadano';
import ApiServices from 'services/ApiServices';

import MensajeAlerta from 'components/ResponseElement'
import Homonimos from 'pages/solicitudesExtranjero/solicitudesNuevas/SolicitudesEmpadronamiento/homonimos'
import ComponenteValidandoEstadosDelPadron from'pages/solicitudesExtranjero/solicitudesNuevas/SolicitudesEmpadronamiento/citizenIdentityData/EmpadronarActualizar/CreateUpdateUser/ValidarEstadosPadron'
import { showMessagePersonalizedPosition } from 'services/SweetAlert';
import DialogLoadingMessage from 'components/BackDrop';

function DatosResumen(props) {   
    const classes = useStyles();
    const [showDialogHomonimos, setShowDialogHomonimos] = useState(false);
    const [arrayHomonimos, setArrayHomonimos] = useState([]),
    [open, setOpen] = useState(false),
    [controller] = useState("verificarHomonimos"),
    [mensaje, setMensaje] = useState({tipoError:'', tipoMensaje:''});
    const [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});

    const [user] = useState([
        {title: 'Nombre completo', value: props.datosSolicitudExtranjero?.nombreCompleto,icon:<AccountCircle/>},
        {title: 'Género', value: (Number(props.datosSolicitudExtranjero.genero) === 1 ? "MASCULINO" : "FEMENINO"), icon: <Wc/>},
        {title: 'Estado en el Padrón', 
            value: ((props.datosSolicitudExtranjero?.estadoPadron?.codStatus ? props.datosSolicitudExtranjero?.estadoPadron?.codStatus: '')+'. '+ (props.datosSolicitudExtranjero?.estadoPadron?.nombreStatus ? props.datosSolicitudExtranjero?.estadoPadron?.nombreStatus : '')), icon:<Person/>},
        {title: 'Número de boleta', value: (props.datosSolicitudExtranjero?.nroBoleta || '-'), icon:<Person/>},
        {title: 'CUI del DPI', value: props.datosSolicitudExtranjero?.dpi, icon:<Person/>},
        {title: 'Número de serie', value: props.datosSolicitudExtranjero?.numeroSerie, icon:<Person/>},
        {title: 'Fecha de Nacimiento', value: functions.dateFormatGeneral(props.datosSolicitudExtranjero?.fechaNacimiento), icon: <Today/>},
        {title: 'Lugar de Nacimiento', value: props.datosSolicitudExtranjero.lugarNacimiento, icon: <LocationOn/>},
        {title: 'Nombre del Padre', value: `${props.datosSolicitudExtranjero.primerNombrePadre} ${props.datosSolicitudExtranjero.segundoNombrePadre} ${', '} ${props.datosSolicitudExtranjero.primerApellidoPadre} ${props.datosSolicitudExtranjero.segundoApellidoPadre}`, 
            icon: <Person/>
        },
        {title: 'Nombre de la Madre', value: `${props.datosSolicitudExtranjero.primerNombreMadre} ${props.datosSolicitudExtranjero.segundoNombreMadre} ${', '} ${props.datosSolicitudExtranjero.primerApellidoMadre} ${props.datosSolicitudExtranjero.segundoApellidoMadre}`, 
            icon: <Person/>
        },        
    ])
    const nextStep=()=>{

        // if(props.datosIdentidadFoto.fotosVieneVacio && !props.datoIdentidadFotoIngresada) {
        //     setMensaje({tipoError:'error', tipoMensaje:'La foto del ciudadano es requerida'})
        //     setOpen(true)
        //     return;
        // }

        // if(!props.nroBoleta) {
            searchHomonyms();
        //     return;
        // }
        // props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(props.step+1);    
    };
    const Cerrar=()=>{
        props.CLEAR_DATA_IS_REGISTERED()
        props.cerrarDialogo()
    };

    const searchHomonyms = async () => {
        setLoadingMessage({loading: true, title:'Buscando Homónimos ...'})
        const {primerNombre, segundoNombre, primerApellido, segundoApellido, departamentoNacimiento, municipioNacimiento, dpi, numeroDeLaCedula, ordenDeNumeracionCedula} = props.datosSolicitudExtranjero;

        const filters = {
            municipioNacio :"0",
            departamentoNacio : "0",
            fechaNacio : functions.dateFormatGeneral(props.datosSolicitudExtranjero.fechaNacimiento),
            nom1 : primerNombre,
            nom2 : segundoNombre,
            ape1 : primerApellido,
            ape2 : segundoApellido,
            cui: '',
            ordenCedula : '',
            registroCedula: ''
            // genero: "",
            // fechaNacio : "",
        }

        try {
            props.SET_DATOS_GENERALES_DEL_CIUDADANO({...props.datosGeneralesDelCiudadano, nom1: primerNombre, nom2: segundoNombre,  ape1: primerApellido, ape2: segundoApellido, fechaNacimiento: props.datosSolicitudExtranjero.fechaNacimiento});
            setArrayHomonimos([])
            setShowDialogHomonimos(false)
            const hasPermission = await ApiServices.userSecurity.hasPermission('verificarHomonimos','list');    
            if (hasPermission.error){
                setLoadingMessage({loading: false, title:''})
                setShowDialogHomonimos(false)
                setMensaje({ tipoError: 'error', tipoMensaje: hasPermission.error.message });
                return;
            }
           ApiServices[controller].initSearchCriteria.clear();
           ApiServices[controller].initSearchCriteria.setOperator("and");
           ApiServices[controller].initSearchCriteria.addEquals("municipioNacio", filters.municipioNacio);  
           ApiServices[controller].initSearchCriteria.setOperator("and");
           ApiServices[controller].initSearchCriteria.addEquals("departamentoNacio", filters.departamentoNacio);  
           ApiServices[controller].initSearchCriteria.setOperator("and");
           ApiServices[controller].initSearchCriteria.addEquals("fechaNacio", filters.fechaNacio);  
           ApiServices[controller].initSearchCriteria.setOperator("and");
           ApiServices[controller].initSearchCriteria.addEquals("nom1", filters.nom1);  
           ApiServices[controller].initSearchCriteria.setOperator("and");
           ApiServices[controller].initSearchCriteria.addEquals("nom2", filters.nom2);  
           ApiServices[controller].initSearchCriteria.setOperator("and");
           ApiServices[controller].initSearchCriteria.addEquals("ape1", filters.ape1);  
           ApiServices[controller].initSearchCriteria.setOperator("and");
           ApiServices[controller].initSearchCriteria.addEquals("ape2", filters.ape2);  
           ApiServices[controller].initSearchCriteria.setOperator("and");
           ApiServices[controller].initSearchCriteria.addEquals("cui", filters.cui);  
           ApiServices[controller].initSearchCriteria.setOperator("and");
           ApiServices[controller].initSearchCriteria.addEquals("ordenCedula", filters.ordenCedula);  
           ApiServices[controller].initSearchCriteria.setOperator("and");
           ApiServices[controller].initSearchCriteria.addEquals("registroCedula", filters.registroCedula);  
        //    ApiServices[controller].initSearchCriteria.addEquals("genero", filters.genero);  
           setShowDialogHomonimos(true)
        } catch (error) {
            if (error.status === 404) {
                showMessagePersonalizedPosition('error', '¡Advertencia! ' , 'Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            } else {
                showMessagePersonalizedPosition('error', '¡Advertencia! ' , 'Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }
        }
        setLoadingMessage({loading: false, title:''})
    }

    
    const closeDialogHomonimos = () => {
        setShowDialogHomonimos(false);
    }

    const handClose = (event, reason) =>{
        if (reason === 'clickaway') {return ;}
        setOpen(false)
    }

    return (
        <Grid container className={classes.marginBotton}>
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            {showDialogHomonimos && (
                <Homonimos cerrarDialogo={closeDialogHomonimos} arrayHomonimos={arrayHomonimos} showDialogHomonimos={showDialogHomonimos} />
            )}
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>FOTO, FIRMA, HUELLA</strong> <Divider /></div>
            </Grid >
            <Grid item xs={12}>
               <DatosDeIdentidadCiudadano />
            </Grid > 

            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>DATOS GENERALES DEL CIUDADANO</strong> <Divider /></div>
            </Grid >
            {
                user.map((text, index) => {
                    return (
                        <>
                        <Grid item xs={3}>
                            <ListItem className={classes.rootListItem}>
                                <ListItemText className={classes.rootListItemText}  primary={text.title} />
                                <ListItemIcon className={classes.colorIcon}>{text.icon}</ListItemIcon>
                            </ListItem>
                        </Grid > 
                        <Grid item xs={3}>
                            <Chip variant="outlined" className={classes.colorChip}  label={text.value} />
                        </Grid >
                    </>
                    )
                })                                
            }
            <Grid item xs={12} className={classes.cardButtons}>
                <BotonPersonalizado title={"Siguiente"} botonSiguiente={true} function={nextStep}/>                                       
                <BotonPersonalizado title={"Cerrar"} botonNormalCancelar={true} function={Cerrar} /> 
            </Grid>        
            <MensajeAlerta type={mensaje.tipoError} content={mensaje.tipoMensaje} timeMessage={2000} open={open} handClose={handClose} />
            <ComponenteValidandoEstadosDelPadron data={props.datosSolicitudExtranjero} funcionObtenerEstadoEnElPadron={()=>{}}/>
            <div className={classes.lineaDegradadaBottom}></div>                   
        </Grid>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(DatosResumen);